export default {
  FETCH_LOOKUP: "FETCH_LOOKUP",
  FETCH_LOOKUP_SUCCEEDED: "FETCH_LOOKUP_SUCCEEDED",
  FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY:
    "FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY",
  FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY_SUCCEEDED:
    "FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY_SUCCEEDED",
  CHECK_DUBPLICATE_OF: "CHECK_DUBPLICATE_OF",
  CHECK_DUBPLICATE_OF_SUCCEEDED: "CHECK_DUBPLICATE_OF_SUCCEEDED",
  RESET_DUPLICATE_BPS: "RESET_DUPLICATE_BPS",
  DELETE_DUPLICATE_BP: "DELETE_DUPLICATE_BP",
  DELETE_DUPLICATE_BP_SUCCEEDED: "DELETE_DUPLICATE_BP_SUCCEEDED",
  RESET_DUPLICATE_BP_DELETED_FLAG: "RESET_DUPLICATE_BP_DELETED_FLAG",

  CREATE_CITY: "CREATE_CITY",
  CREATE_CITY_SUCCEEDED: "CREATE_CITY_SUCCEEDED",
  CREATE_POBOX_CITY_SUCCEEDED: "CREATE_POBOX_CITY_SUCCEEDED",
  RESET_CITY_CREATED_FLAG: "RESET_CITY_CREATED_FLAG",

  UPDATE_CITY: "UPDATE_CITY",
  UPDATE_CITY_SUCCEEDED: "UPDATE_CITY_SUCCEEDED",
  UPDATE_POBOX_CITY_SUCCEEDED: "UPDATE_POBOX_CITY_SUCCEEDED",
  RESET_CITY_UPDATED_FLAG: "RESET_CITY_UPDATED_FLAG",

  CREATE_BUSINESS_PARTNER: "CREATE_BUSINESS_PARTNER",
  CREATE_BUSINESS_PARTNER_SUCCEEDED: "CREATE_BUSINESS_PARTNER_SUCCEEDED",
  UPDATE_BUSINESS_PARTNER: "UPDATE_BUSINESS_PARTNER",
  UPDATE_BUSINESS_PARTNER_SUCCEEDED: "UPDATE_BUSINESS_PARTNER_SUCCEEDED",
  RESET_BP_CRREATED_FLAG: "RESET_BP_CRREATED_FLAG",
  RESET_BP_UPDATED_FLAG: "RESET_BP_UPDATED_FLAG",
  SET_SELECTED_BP: "SET_SELECTED_BP",

  CREATE_POSTAL_CODE: "CREATE_POSTAL_CODE",
  CREATE_POSTAL_CODE_SUCCEEDED: "CREATE_POSTAL_CODE_SUCCEEDED",
  CREATE_POBOX_POSTAL_CODE_SUCCEEDED: "CREATE_POBOX_POSTAL_CODE_SUCCEEDED",
  RESET_POSTAL_CODE_CREATED_FLAG: "RESET_POSTAL_CODE_CREATED_FLAG",

  UPDATE_POSTAL_CODE: "UPDATE_POSTAL_CODE",
  UPDATE_POSTAL_CODE_SUCCEEDED: "UPDATE_POSTAL_CODE_SUCCEEDED",
  UPDATE_POBOX_POSTAL_CODE_SUCCEEDED: "UPDATE_POBOX_POSTAL_CODE_SUCCEEDED",
  RESET_POSTAL_CODE_UPDATED_FLAG: "RESET_POSTAL_CODE_UPDATED_FLAG",

  RETAIN_UPDATED_BUSINESS_PARTNER: "RETAIN_UPDATED_BUSINESS_PARTNER",
  RETAIN_UPDATED_BUSINESS_PARTNER_SUCCEEDED:
    "RETAIN_UPDATED_BUSINESS_PARTNER_SUCCEEDED",

  RESET_SELECTED_BP: "RESET_SELECTED_BP",

  DELETE_BUSINESS_PARTNER: "DELETE_BUSINESS_PARTNER",
  DELETE_BUSINESS_PARTNER_SUCCEEDED: "DELETE_BUSINESS_PARTNER_SUCCEEDED",
  RESET_DELETE_BP_SUCCEEDED: "RESET_DELETE_BP_SUCCEEDED",
  FLUSH_COUNTRY_DEPENDENT_LOOKUP_DATA: "FLUSH_COUNTRY_DEPENDENT_LOOKUP_DATA",
  FETCH_BIC_SWIFTS: "FETCH_BIC_SWIFTS",
  FETCH_BIC_SWIFTS_SUCCEEDED: "FETCH_BIC_SWIFTS_SUCCEEDED",
  RESET_BIC_SWIFTS: "RESET_BIC_SWIFTS",
  FETCH_BANK_BRANCH: "FETCH_BANK_BRANCH",
  FETCH_BANK_BRANCH_SUCCEEDED: "FETCH_BANK_BRANCH_SUCCEEDED",
  RESET_BANK_BRANCH: "RESET_BANK_BRANCH"
};
